

$('.js-close-info-popup').click(function(){
    let popup = $(this).closest('.js-info-popup')
    popup.fadeOut()
})